// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setCloudId(ydb: Database, fieldId: string, cloudId: string): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];

    field.cloudId = cloudId;
  });
}
